import React, {Fragment, useEffect, useState} from 'react'
import {connect} from 'react-redux';
import {getOperators, changePassword} from "./actions";
import _ from 'lodash' ;
import {Link} from "react-router-dom";
import classNames from 'classnames';
import ChangePasswordForm, {formName} from './ChangePasswordForm';
import {reset} from "redux-form";

const Operators = (props) => {

    const {operators} = props ;

    useEffect(() => {
        props.getOperators();
    }, []);

    const [showModal, setShowModal] = useState(false);
    const [currentUser, setCurrentUser] = useState();

    const submitChangePass = (values) => {
        props.changePassword(currentUser, values.password);
    };

    useEffect(() => {
        if (!_.isEmpty(props.changePassResult)) {
            if (props.changePassResult.isSuccess){
                setShowModal(false);
            }
        }
    }, [props.changePassResult]);

    const changeUserPass = (username) => {
        props.reset(formName);
        setCurrentUser(username);
        setShowModal(true);
    };

    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle">
                    <span className=" font-size_24 boldFont middleContext">لیست تمامی اوپراتور ها</span>
                    <div className="normalButton outlineMode greenButton">
                        <Link to={'/operators/new'}>
                            <span className="icon icon-operators font-size_24 middleContext"/> افزودن اوپراتور جدید
                        </Link>
                    </div>
                </div>
            </div>
            <span className="lineSeparator" />
            <div className="maximumSizeHandler">
                <div className="tableStructure">
                    <table>
                        <tr className="font-size_16 mediumWFont">
                            <th>نام</th>
                            <th>ایمیل</th>
                            <th>نام کاربری</th>
                            <th/>
                        </tr>
                        {_.map(operators , operator => {
                            return (
                                <tr key={operator.id} className="font-size_14">
                                    <td>{operator.fullName}</td>
                                    <td>{operator.email}</td>
                                    <td>{operator.userName}</td>
                                    <td>
                                        <span className="icon icon-eraser" />
                                        <Link to={`/operators/${operator.id}`}><span className="icon icon-edit leftMargin greenColor" /></Link>
                                        <span className="icon icon-edit leftMargin" onClick={e => changeUserPass(operator.userName)} />
                                    </td>
                                    {/*<td className="blueColor">مشاهده نتایج <span className="icon icon-left font-size_12"></span></td>*/}
                                </tr>
                            )
                        })}
                    </table>
                </div>
            </div>
            <div className={classNames("popUp", {"tempDisable": !showModal})}>
                <div className="popUpClose" onClick={e => setShowModal(false)} />
                <div className="popUpBox whiteBox relative">
                    <div className="popUpCloseSign">
                        <span className="icon icon-close" onClick={e => setShowModal(false)} />
                    </div>
                    <ChangePasswordForm onSubmit={submitChangePass} />
                </div>
            </div>            
        </Fragment>
    );
};

const mapStateToProps = ({operators, changePassResult}) => ({
    operators,
    changePassResult
});

export default connect(mapStateToProps, {getOperators, reset, changePassword})(Operators);
